export const MOSTRAR_ARTICULO = "MOSTRAR_ARTICULO"
export const MOSTRAR_VIDEO = "MOSTRAR_VIDEO"
export const CAMBIA_ICONO = "CAMBIA_ICONO"
export const ARTICULO_EDITAR = "ARTICULO_EDITAR"
export const CANASTA_EDITAR = "CANASTA_EDITAR"
export const MOSTRAR_CANASTA = "MOSTRAR_CANASTA"
export const ALMACENAR_IMAGEN = "ALMACENAR_IMAGEN"
